import { render, staticRenderFns } from "./DocumentAttributesEditor.vue?vue&type=template&id=b28b8d34&scoped=true&"
import script from "./DocumentAttributesEditor.vue?vue&type=script&lang=ts&"
export * from "./DocumentAttributesEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentAttributesEditor.vue?vue&type=style&index=0&id=b28b8d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28b8d34",
  null
  
)

export default component.exports